var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'c-accordion',
    { active: _vm.actuallyActive === true },
    { 'min-height': _vm.minHeight === true }
  ]},[_c('div',{staticClass:"c-accordion__header",on:{"click":_vm.onToggle}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('article',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_c('chevron-down-icon',{attrs:{"size":"1.5x"}})],1),_c('div',{staticClass:"c-accordion__body"},[_c('div',{staticClass:"c-accordion__body__inner"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }